import { Cell } from '@table-library/react-table-library/table';
import moment from 'moment';
import PromptsModal from './modal';
import ShowAll from './component/showMore';
import { CircleFlag } from 'react-circle-flags';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.prompt_history.table.project'),
        key: 'project',
        data: 'project',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data }) => data?.name || '-',
    },
    {
        label: (
            <div className="ai-tracking-country-language">
                <div className="ai-tracking-country-language-country">
                    {t('ai_tracking.prompt_history.table.brand_name')}
                </div>
                <div className="ai-tracking-country-language-lan">
                    {t('ai_tracking.prompt_history.table.brand_domain')}
                </div>
            </div>
        ),
        key: 'brand_domain',
        data: 'brand_domain',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item?.project?.own_domain;
            return (
                <div className="ai-tracking-country-language">
                    <div className="ai-tracking-country-language-country">
                        {item.brand_name || '-'}
                    </div>
                    <div className="ai-tracking-country-language-lan">
                        {item.brand_domain || '-'}
                    </div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.prompt_history.table.country_language'),
        key: 'country_language',
        data: 'country_language',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item?.country;
            return (
                <div className="ai-tracking-country-language d-flex align-items-center gap-4">
                    {item.country && (
                        <CircleFlag countryCode={item.country.toLowerCase()} height="18" />
                    )}
                    <div className="ai-tracking-country-language-country">{item.country}</div>
                    <div className="ai-tracking-country-language-lan">({item.language})</div>
                </div>
            );
        },
        sortType: (array) =>
            array.sort((a, b) =>
                `${a.country} - ${a.language}`.localeCompare(`${b.country} - ${b.language}`),
            ),
    },
    {
        label: t('ai_tracking.prompt_history.table.entities'),
        key: 'entities',
        data: 'entities',
        Component: Cell,
        cellSize: 'minmax(150px, 1.5fr)',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item?.entities;
            return <ShowAll data={item.entities} />;
        },
    },
    {
        label: t('ai_tracking.prompt_history.table.completed_at'),
        key: 'completed_at',
        data: 'completed_at',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data }) => (data ? moment(data).format('YYYY-MM-DD HH:mm') : '-'),
    },
    {
        label: t('ai_tracking.prompt_history.table.status'),
        key: 'status',
        data: 'status',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data }) => data?.replace(/_/g, ' '),
    },
    {
        label: t('ai_tracking.prompt_history.table.expand_urls'),
        key: 'expand_urls',
        data: 'expand_urls',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            !csvDownload ? <PromptsModal items={item.response_data} /> : item?.entity_prompts,
    },
];
